import { useTranslations } from "@zapier/i18n";
import { ShareEntity } from "./ShareEntity";
import { Member } from "@zapier/bff";
import { Tag, Text } from "@zapier/design-system";
import styles from "./ShareList.module.css";

export function OwnerListItem({ owner }: { owner: Member | undefined }) {
  const t = useTranslations("owner-list-item");

  if (!owner) {
    return;
  }

  return (
    <li className={styles.listItem}>
      <ShareEntity
        imageUrl={owner.photoUrl}
        label={<Text type="Body3">{owner.fullName}</Text>}
        name={owner.fullName}
      />

      <div className={styles.accessControl}>
        <Tag variant="inverted">{t("roles.owner")}</Tag>
      </div>
    </li>
  );
}
